import { useState } from "react";
import { Camera, ShieldCheck, Sparkles, X } from "lucide-react";

const KEY = "ts_new_user_explainer_dismissed";
const CARDS = [
  { Icon: Camera, title: "Document your rental", body: "Capture photos, video and details of each room to build a timestamped record." },
  { Icon: ShieldCheck, title: "Keep a tamper-evident record", body: "Lock your documentation so it can’t be changed later — verify it anytime." },
  { Icon: Sparkles, title: "Explore the sample property", body: "See a fully documented example before you start your own." },
];

// New-user, non-blocking, dismissible explainer. Dismissal persists across sessions.
export function NewUserExplainer({ onStart, onSample }) {
  const [dismissed, setDismissed] = useState(() => { try { return localStorage.getItem(KEY) === "1"; } catch { return false; } });
  if (dismissed) return null;
  const close = () => { try { localStorage.setItem(KEY, "1"); } catch { /* ignore */ } setDismissed(true); };
  return (
    <div data-testid="new-user-explainer" className="relative mb-6 rounded-2xl border border-[#E2E8F0] bg-white p-5">
      <button data-testid="explainer-dismiss" onClick={close} aria-label="Dismiss" className="absolute top-3 right-3 text-[#94A3B8] hover:text-[#475569]"><X size={18} /></button>
      <h2 className="font-heading text-xl font-bold text-navy">Welcome to TenantSeal</h2>
      <div className="mt-4 grid gap-3 sm:grid-cols-3">
        {CARDS.map((c, i) => (
          <div key={i} data-testid={`explainer-card-${i}`} className="rounded-xl bg-[#F8FAFC] border border-[#E2E8F0] p-4">
            <span className="grid place-items-center h-9 w-9 rounded-lg bg-brand/10 text-brand"><c.Icon size={18} /></span>
            <h3 className="mt-2.5 font-semibold text-sm text-navy">{c.title}</h3>
            <p className="mt-1 text-xs text-[#64748B]">{c.body}</p>
          </div>
        ))}
      </div>
      <div className="mt-4 flex flex-wrap gap-2">
        <button data-testid="explainer-start-btn" onClick={onStart} className="rounded-xl bg-brand hover:bg-brand-hover text-white text-sm font-semibold px-5 h-11">Start documenting</button>
        <button data-testid="explainer-sample-btn" onClick={onSample} className="rounded-xl border border-[#E2E8F0] text-navy text-sm font-medium px-5 h-11 hover:bg-[#F1F5F9]">Explore sample property</button>
      </div>
    </div>
  );
}
